import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck, Inject, OnDestroy  } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent, DwMetaDataGridActionState,
         DwDateTimeInputOptions, DwOrmDataServiceToken, DwOrmDataService, DwMetaDataFormStateService, DwGridEvents,
         DwMetaDataFormApi, DwEventService, DwMdEventService, DwGridEvent, DwEvent, DwMdLoadEventData, DwGridDeleteActionService,
         DwAction, DwGridActionConfig, DwMetaDataFilter, DwActionPreference, DwMetaDataGridApi, DwMetaDataService, DwMetaDataServiceToken,
         DwActionType, DwDecoratorType, DwQueryHelper, DwFormContextMode, DwMetaDataGridPreferences, DwGridActionResult } 
         from '@devwareapps/devware-cap';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { FleetMetaDataItemNames, FleetMetaDataLookups, MaintenanceEntity, ServiceTypeEntity, FleetVehicleEntity } 
         from '../meta-data/fleet-meta-data.service';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, Subscription, of } from 'rxjs';
import { QueryString } from '../../../shared/services/querystring.service';
import * as moment_ from 'moment';
import { AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
const moment = moment_;

@DwAction<DwGridActionConfig>({
    keyName: 'maintenanceAddFor',
    display: 'Add Maintenance For',
    actionType: DwActionType.gridAction,
    decoratorType: DwDecoratorType.component,
    isGlobal: false,
    parentItemName: FleetMetaDataItemNames.Maintenance,
    allowOnce: true,
})
@Component({
  selector: 'vehicle-maintenance-add-for',
  template: `<button type="button" class="btn btn-success" [hidden]="vid == undefined" 
                    [routerLink]="['/fleet/vehicle-maintenance/add']" [queryParams]="{ VehicleId: vid }"  
                    title="Add for ''{{uid}}''"><i class="dw-icon-add"></i> Add for '{{uid}}' </button>`
})
export class AddMaintenanceAddForComponent {
    uid: string = '';    
    vid: number = undefined;
    constructor(private dwSecurityUserService: DwSecurityUserService,
            private queryString : QueryString,
            private dwGridDeleteActionService : DwGridDeleteActionService,
            @Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
            @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
            private dwEventService: DwEventService) 
    {
        this.uid = queryString.getString("UnitId") ?? "";
        if (this.uid.length > 0)
            this.loadVehicle(this.uid).subscribe(v =>{
                this.vid = v?.VehicleId;
            });

    }

    loadVehicle(unitId: string) : Observable<FleetVehicleEntity>{
        const md = new AppMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.FleetVehicle.CreateQuery().AddFilterAnd(qh.filters.Equal(md.FleetVehicle.UnitId, unitId));
        return this.dataService.executeQuerySingle(query);
    }
}
